unit WebScannerForm;

interface

uses
  System.SysUtils, System.Classes, Web, JS,
  WebLib.Forms, WebLib.Controls, WebLib.StdCtrls, WebLib.WebCtrls, Vcl.StdCtrls,
  Vcl.Controls, WebLib.ExtCtrls;

type
  TfrmScanner = class(TForm)
    Panel: TPanel;
    VideoHost: THTMLDiv;
    BottomBar: TPanel;
    btnCancel: TButton;
    lblHint: TLabel;
    WebLabel1: TLabel;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
    procedure btnCancelClick(Sender: TObject);
  private
    FReader: JSValue; // ZXing.BrowserMultiFormatReader
    FControls: JSValue; // ZXing controls (to stop the stream)
    FLastScanValue: string;
    FLastFormat: string;
    FClosing: Boolean;
    procedure StartScan;
    procedure StopScan;
  public
    property LastScanValue: string read FLastScanValue;
    property LastFormat: string read FLastFormat;
  protected procedure LoadDFMValues; override; end;

var
  frmScanner: TfrmScanner;

implementation

{$R *.dfm}

procedure TfrmScanner.WebFormCreate(Sender: TObject);
begin
  // Simple modal styling
//  Panel.ElementClassName := 'tw-modal';
//  Panel.ElementHandle.style.setProperty('position', 'fixed');
//  Panel.ElementHandle.style.setProperty('inset', '0');
//  Panel.ElementHandle.style.setProperty('background', 'rgba(0,0,0,0.5)');
//  Panel.ElementHandle.style.setProperty('display', 'flex');
//  Panel.ElementHandle.style.setProperty('align-items', 'center');
//  Panel.ElementHandle.style.setProperty('justify-content', 'center');
//
//  // Inner container for the video
//  VideoHost.WidthStyle := ssPercent;
//  VideoHost.HeightStyle := ssAuto;
//  VideoHost.WidthPercent := 90;
//  VideoHost.ElementHandle.style.setProperty('max-width', '520px');
//  VideoHost.ElementHandle.style.setProperty('background', '#111');
//  VideoHost.ElementHandle.style.setProperty('border-radius', '12px');
//  VideoHost.ElementHandle.style.setProperty('padding', '12px');
//
//  BottomBar.Align := alBottom;
//  BottomBar.ElementHandle.style.setProperty('display', 'flex');
//  BottomBar.ElementHandle.style.setProperty('gap', '8px');
//  BottomBar.ElementHandle.style.setProperty('justify-content', 'space-between');
//  BottomBar.ElementHandle.style.setProperty('align-items', 'center');

  btnCancel.Caption := 'Cancel';
  lblHint.Caption := 'Point the camera at a QR/Barcode…';

  // Inject a real <video> element we’ll give to ZXing (by id)
  // playsinline avoids iOS full-screen
  VideoHost.HTML.Text :=
    '<video id="scanner_video" autoplay playsinline style="width:100%;height:auto;border-radius:8px;"></video>';

  FReader := nil;
  FControls := nil;
  FClosing := False;
end;

procedure TfrmScanner.WebFormShow(Sender: TObject);
begin
  StartScan;
end;

procedure TfrmScanner.WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
begin
  // Ensure the camera is released when closing
  if not FClosing then
  begin
    FClosing := True;
    StopScan;
  end;
  CanClose := True;
end;

procedure TfrmScanner.StartScan;
begin
  asm
    // Create a singleton reader for this form instance
    if (!this.FReader) {
    this.FReader = new ZXing.BrowserMultiFormatReader();
     }

    const videoId = 'scanner_video';

    this.FReader.listVideoInputDevices().then(devices => {
    // Prefer back camera when available
    let deviceId = null;
    const back = devices.find(d => /back|rear|environment/i.test(d.label));
    if (back) deviceId = back.deviceId;

    this.FReader.decodeFromVideoDevice(deviceId, videoId, (result, err, controls) => {
    if (controls && !this.FControls) {
    this.FControls = controls; // stow stop controls
     }

    if (result) {
    // Capture data and close modal
    this.FLastScanValue = result.text;
    try { this.FLastFormat = result.getBarcodeFormat(); } catch(e) { this.FLastFormat = ''; }

    if (this.FControls) { this.FControls.stop(); this.FControls = null; }
    this.ModalResult = mrOk;
    this.Close();
    return;
    }

    // NotFoundException is normal while scanning — ignore
    // console.log(err); // uncomment to debug
    });
    }).catch(e => {
    console.error(e);
    this.lblHint.Caption = 'Camera error: ' + e;
     });
  end; end;

  procedure TfrmScanner.StopScan; begin
  asm
    try {
    if (this.FControls) {
    this.FControls.stop();
    this.FControls = null;
     }
    } catch(e) { console.warn(e); }
  end; end;

  procedure TfrmScanner.btnCancelClick(
Sender:
  TObject); begin StopScan; ModalResult := mrCancel; Close;
  // will trigger the ShowModal callback
  end;

  procedure TfrmScanner.LoadDFMValues;
begin
  inherited LoadDFMValues;

  Panel := TPanel.Create(Self);
  VideoHost := THTMLDiv.Create(Self);
  BottomBar := TPanel.Create(Self);
  lblHint := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  btnCancel := TButton.Create(Self);

  Panel.BeforeLoadDFMValues;
  VideoHost.BeforeLoadDFMValues;
  BottomBar.BeforeLoadDFMValues;
  lblHint.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  try
    Name := 'frmScanner';
    Width := 640;
    Height := 480;
    Align := alClient;
    Caption := 'frmScanner';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    Panel.SetParentComponent(Self);
    Panel.Name := 'Panel';
    Panel.Left := 0;
    Panel.Top := 0;
    Panel.Width := 640;
    Panel.Height := 420;
    Panel.Center.Horizontal := True;
    Panel.Align := alClient;
    Panel.Caption := 'Panel11';
    Panel.TabOrder := 0;
    VideoHost.SetParentComponent(Panel);
    VideoHost.Name := 'VideoHost';
    VideoHost.Left := 0;
    VideoHost.Top := 0;
    VideoHost.Width := 640;
    VideoHost.Height := 420;
    VideoHost.Center.Horizontal := True;
    VideoHost.Anchors := [];
    VideoHost.Role := '';
    BottomBar.SetParentComponent(Self);
    BottomBar.Name := 'BottomBar';
    BottomBar.Left := 0;
    BottomBar.Top := 420;
    BottomBar.Width := 640;
    BottomBar.Height := 60;
    BottomBar.Center.Horizontal := True;
    BottomBar.Align := alBottom;
    BottomBar.Anchors := [akBottom];
    BottomBar.Caption := 'BottomBar';
    BottomBar.ChildOrder := 1;
    BottomBar.TabOrder := 1;
    lblHint.SetParentComponent(BottomBar);
    lblHint.Name := 'lblHint';
    lblHint.Left := 96;
    lblHint.Top := 16;
    lblHint.Width := 36;
    lblHint.Height := 15;
    lblHint.Caption := 'lblHint';
    lblHint.HeightPercent := 100.000000000000000000;
    lblHint.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(BottomBar);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 552;
    WebLabel1.Top := 16;
    WebLabel1.Width := 25;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'test1';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    btnCancel.SetParentComponent(BottomBar);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 424;
    btnCancel.Top := 24;
    btnCancel.Width := 96;
    btnCancel.Height := 25;
    btnCancel.Anchors := [];
    btnCancel.Caption := 'btnCancel';
    btnCancel.ChildOrder := 1;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
  finally
    Panel.AfterLoadDFMValues;
    VideoHost.AfterLoadDFMValues;
    BottomBar.AfterLoadDFMValues;
    lblHint.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
  end;
end;

end.
